// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-image-container {
    position: relative;
    width: 100%; /* Adjust as needed */
    height: 400px; /* Adjust as needed */
    margin: 0 auto; /* Centers the container */
  }
  
  .overlay-image {
    position: absolute;
    left: 80%;
    top: 45%;
    transform: translate(-50%, -50%); /* Centers the image within the container */
    max-width: 100%; /* Ensures the image is contained within the parent */
    max-height: 100%;
    transition: transform 0.5s ease-in-out;
    animation: float 5s ease-in-out infinite;
  }
  

/* Styling and animation for the first image */
.overlay-image.first {
  z-index: 2;
  /* left: 5%;
  top: 10%; */
  opacity: 0.8;
top: 16% ;
left: 71%;
  transform: rotate(-10deg);
}

/* Styling and animation for the second image */
.overlay-image.second {
  z-index: 2;
  right: 15%;
   top: 31%;
  /*
  width: 80%; */
  transform: rotate(10deg);
}

/* Styling and animation for the third image */
.overlay-image.third {
  z-index: 1;
  /* left: 10%; */
  /* bottom: 15%;
  width: 60%; */
  top:36%;
  left: 75%;
  opacity: 0.8;
  transform: rotate(-5deg);
  border-radius: 30px;
}

/* Floating animation */
@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

  


  .hero-body{
    font: 1.6rem "FS Sinclair Medium";
    box-sizing: border-box;
    overflow: hidden;
    margin: 0;
    height: 34vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  

  .background {
    background-image: url(https://images.unsplash.com/photo-1554692760-4b7e52978fb6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80);
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #252746;
    background-position: center;
    width: 100%;
    height: 30vh;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
  }
  
  .background-texture {
    background: linear-gradient(
      to top,
      rgba(166, 223, 216, 1),
      rgba(255, 255, 255, 0.9)
    );
    background-size: cover;
    width: 100%;
    height: 34vh;
    position: absolute;
    z-index: 0;
    top: 105;
    left: 0;
  }
  
  .header {
    width: 100%;

  
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    /* margin-top: 70px; */
    z-index: 1;
  }
  
  .left-content {
    padding-left: 40px;
  }
  
  .stay-home {
    font-size: 1.5rem;
    text-transform: uppercase;
    letter-spacing: 0.5rem;
    margin-bottom: 0;
    color: #8b64b4;
  }
  
  .hero-h1 {
    margin: 0 0 1rem 0;
    font-weight: 900;
    font-size: 4.5rem;
   
    color: #3b365e;
  }

  .para{
    font-size: 1.5rem;
    color: #3b365e;
  }
  

  .hero-button {
    padding: 0.9rem 1.2rem;
    border-radius: 25px;
    background-color: white;
    border: 0;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    font-size: 1rem;
    color:rgb(172, 38, 59);
    cursor: pointer;
  }


  
  .hero-button1 {
    padding: 0.7rem 0.8rem;
    border-radius: 25px;
    background-color: white;
    border: 0;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    font-size: 0.9rem;
    color:rgb(172, 38, 59);
    cursor: pointer;
    font-family: "FS Sinclair Medium";
    /* border: 1px solid rgb(192, 185, 186); */
  }
  

  .hero-button:hover {
    background-color: #f2f2f2;
  }

  .hero-button1:hover {
    background-color: #f2f2f2;
  }
  

  @media screen and (max-width: 1458px) {
    .header {
      height: 30vh;
      display: flex;
      justify-content: space-between;
      align-items: left;
    }

    .left-content {
      width: 100%;
      padding: 0 20px;
    }

    .hero-h1 {
      font-size: 2rem;
    }

    .hero-button {
      padding: 0.8rem 1rem;
    }

    .para{
      font-size: 1rem;
    }
    
    .hero-button1{
      font-size: 0.8rem;
      /* width: 50px; */
    }
  }
`, "",{"version":3,"sources":["webpack://./src/pages/howToUseSM/HeroSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW,EAAE,qBAAqB;IAClC,aAAa,EAAE,qBAAqB;IACpC,cAAc,EAAE,0BAA0B;EAC5C;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC,EAAE,2CAA2C;IAC7E,eAAe,EAAE,qDAAqD;IACtE,gBAAgB;IAChB,sCAAsC;IACtC,wCAAwC;EAC1C;;;AAGF,8CAA8C;AAC9C;EACE,UAAU;EACV;aACW;EACX,YAAY;AACd,SAAS;AACT,SAAS;EACP,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,UAAU;EACV,UAAU;GACT,QAAQ;EACT;eACa;EACb,wBAAwB;AAC1B;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,eAAe;EACf;eACa;EACb,OAAO;EACP,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;;;;EAKE;IACE,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;;EAGA;IACE,0JAA0J;IAC1J,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;EACT;;EAEA;IACE;;;;KAIC;IACD,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,OAAO;EACT;;EAEA;IACE,WAAW;;;IAGX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;;IAEjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;;EAGA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,eAAe;EACjB;;;;EAIA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,iCAAiC;IACjC,0CAA0C;EAC5C;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE;MACE,YAAY;MACZ,aAAa;MACb,8BAA8B;MAC9B,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF","sourcesContent":[".hero-image-container {\r\n    position: relative;\r\n    width: 100%; /* Adjust as needed */\r\n    height: 400px; /* Adjust as needed */\r\n    margin: 0 auto; /* Centers the container */\r\n  }\r\n  \r\n  .overlay-image {\r\n    position: absolute;\r\n    left: 80%;\r\n    top: 45%;\r\n    transform: translate(-50%, -50%); /* Centers the image within the container */\r\n    max-width: 100%; /* Ensures the image is contained within the parent */\r\n    max-height: 100%;\r\n    transition: transform 0.5s ease-in-out;\r\n    animation: float 5s ease-in-out infinite;\r\n  }\r\n  \r\n\r\n/* Styling and animation for the first image */\r\n.overlay-image.first {\r\n  z-index: 2;\r\n  /* left: 5%;\r\n  top: 10%; */\r\n  opacity: 0.8;\r\ntop: 16% ;\r\nleft: 71%;\r\n  transform: rotate(-10deg);\r\n}\r\n\r\n/* Styling and animation for the second image */\r\n.overlay-image.second {\r\n  z-index: 2;\r\n  right: 15%;\r\n   top: 31%;\r\n  /*\r\n  width: 80%; */\r\n  transform: rotate(10deg);\r\n}\r\n\r\n/* Styling and animation for the third image */\r\n.overlay-image.third {\r\n  z-index: 1;\r\n  /* left: 10%; */\r\n  /* bottom: 15%;\r\n  width: 60%; */\r\n  top:36%;\r\n  left: 75%;\r\n  opacity: 0.8;\r\n  transform: rotate(-5deg);\r\n  border-radius: 30px;\r\n}\r\n\r\n/* Floating animation */\r\n@keyframes float {\r\n  0%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n\r\n  \r\n\r\n\r\n  .hero-body{\r\n    font: 1.6rem \"FS Sinclair Medium\";\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    margin: 0;\r\n    height: 34vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n\r\n  .background {\r\n    background-image: url(https://images.unsplash.com/photo-1554692760-4b7e52978fb6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80);\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-color: #252746;\r\n    background-position: center;\r\n    width: 100%;\r\n    height: 30vh;\r\n    position: absolute;\r\n    z-index: 0;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n  \r\n  .background-texture {\r\n    background: linear-gradient(\r\n      to top,\r\n      rgba(166, 223, 216, 1),\r\n      rgba(255, 255, 255, 0.9)\r\n    );\r\n    background-size: cover;\r\n    width: 100%;\r\n    height: 34vh;\r\n    position: absolute;\r\n    z-index: 0;\r\n    top: 105;\r\n    left: 0;\r\n  }\r\n  \r\n  .header {\r\n    width: 100%;\r\n\r\n  \r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: relative;\r\n    /* margin-top: 70px; */\r\n    z-index: 1;\r\n  }\r\n  \r\n  .left-content {\r\n    padding-left: 40px;\r\n  }\r\n  \r\n  .stay-home {\r\n    font-size: 1.5rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5rem;\r\n    margin-bottom: 0;\r\n    color: #8b64b4;\r\n  }\r\n  \r\n  .hero-h1 {\r\n    margin: 0 0 1rem 0;\r\n    font-weight: 900;\r\n    font-size: 4.5rem;\r\n   \r\n    color: #3b365e;\r\n  }\r\n\r\n  .para{\r\n    font-size: 1.5rem;\r\n    color: #3b365e;\r\n  }\r\n  \r\n\r\n  .hero-button {\r\n    padding: 0.9rem 1.2rem;\r\n    border-radius: 25px;\r\n    background-color: white;\r\n    border: 0;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2rem;\r\n    font-size: 1rem;\r\n    color:rgb(172, 38, 59);\r\n    cursor: pointer;\r\n  }\r\n\r\n\r\n  \r\n  .hero-button1 {\r\n    padding: 0.7rem 0.8rem;\r\n    border-radius: 25px;\r\n    background-color: white;\r\n    border: 0;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.1rem;\r\n    font-size: 0.9rem;\r\n    color:rgb(172, 38, 59);\r\n    cursor: pointer;\r\n    font-family: \"FS Sinclair Medium\";\r\n    /* border: 1px solid rgb(192, 185, 186); */\r\n  }\r\n  \r\n\r\n  .hero-button:hover {\r\n    background-color: #f2f2f2;\r\n  }\r\n\r\n  .hero-button1:hover {\r\n    background-color: #f2f2f2;\r\n  }\r\n  \r\n\r\n  @media screen and (max-width: 1458px) {\r\n    .header {\r\n      height: 30vh;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: left;\r\n    }\r\n\r\n    .left-content {\r\n      width: 100%;\r\n      padding: 0 20px;\r\n    }\r\n\r\n    .hero-h1 {\r\n      font-size: 2rem;\r\n    }\r\n\r\n    .hero-button {\r\n      padding: 0.8rem 1rem;\r\n    }\r\n\r\n    .para{\r\n      font-size: 1rem;\r\n    }\r\n    \r\n    .hero-button1{\r\n      font-size: 0.8rem;\r\n      /* width: 50px; */\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
